import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
  background-color: black;
`;

export default {
  Container
};



// WEBPACK FOOTER //
// ./src/pages/Home/styles.js